import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LIMIT } from 'data/global';
import { NavigationVariants } from 'models/Navigation';
import SingleSelectDropdownFilter from 'components/SingleSelectDropdownFilter';
import useMatchMedia from 'hooks/useMatchMedia';

import './NumberOfResultsPerPageFilter.styles.scss';

export const PER_PAGE = {
  25: '25',
  [DEFAULT_LIMIT]: DEFAULT_LIMIT,
  75: '75',
  100: '100',
  250: '250',
} as const;

type NumberOfResultsPerPageFilterProps = {
  className?: string;
  variant?: NavigationVariants;
  limit: string;
  renderAsPortal?: boolean;
  updateLimit: (limit: string) => void;
};

const NumberOfResultsPerPageFilter: React.FC<
  NumberOfResultsPerPageFilterProps
> = (props) => {
  const { className, variant, limit, renderAsPortal, updateLimit } = props;

  const classes = classNames('number-of-results-per-page-filter', className);

  const isPhablet = useMatchMedia('isPhablet');

  const { t } = useTranslation();

  const showLimitText = useCallback(
    (limit: string, showFullText = true) =>
      showFullText ? t('perPage', { count: +limit }) : limit,
    [t],
  );

  return (
    <SingleSelectDropdownFilter
      className={classes}
      variant={variant}
      renderAsPortal={renderAsPortal}
      selectedValue={limit}
      triggerTitle={showLimitText(limit, !isPhablet)}
      options={Object.values(PER_PAGE).map((value) => ({
        value,
        label: showLimitText(value, isPhablet),
      }))}
      onChange={updateLimit}
    />
  );
};

export default NumberOfResultsPerPageFilter;
